import { auth } from "../firebase";
import { GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";

const provider = new GoogleAuthProvider();
provider.addScope('profile');
provider.addScope('email');

export const googleLogin = async () => {
  try {
    console.log('Starting Google sign-in...');
    const result = await signInWithPopup(auth, provider);
    console.log('Sign-in successful:', result.user.displayName);
    return result.user;
  } catch (error) {
    console.error('Firebase auth error:', error.code, error.message);
    throw error;
  }
};

export const logout = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error('Logout error:', error);
    throw error;
  }
};
